import { inject, Injectable } from '@angular/core';
import { OtpRepository } from '../../../@core/repositories/otp.repository';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestOtpV3Dto, RequestOtpV3Resp } from '@usecase/otp/request-otp-v3/request-otp-v3.type';
import { RequestOtpDto, RequestOtpResp } from '@usecase/otp/request-otp/request-otp.type';
import { HttpService } from '@shared/services.http';
import { ValidateOtpDto, ValidateOtpPayloadDto, ValidateOtpRespDto } from '@data/data/models/validate-otp.dto';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class OtpAdapter extends OtpRepository {
    private readonly httpService = inject(HttpService);

    requestOtp(payload: RequestOtpDto): Observable<RequestOtpResp> {
        return this.httpService.post(`${environment.serviceApi}request/otp`, payload);
    }
    requestOtpV3(payload: RequestOtpV3Dto): Observable<RequestOtpV3Resp> {
        return this.httpService.post(`${environment.serviceApi}v3/request/otp`, payload);
    }
    requestOtpRenewalPackage(payload: RequestOtpV3Dto): Observable<null> {
        return this.httpService.post<null, RequestOtpV3Dto>(`${environment.serviceApi}v1/renewal-contract/otp/request`, payload).pipe(
            map((res: null) => res),
            catchError((error: HttpErrorResponse) => {
                return throwError(() => error.error);
            })
        );
    }

    validateOtp(payload: ValidateOtpPayloadDto): Observable<ValidateOtpDto> {
        return this.httpService.post<ValidateOtpRespDto, ValidateOtpPayloadDto>(`${environment.serviceApi}v1/renewal-contract/otp/validation`, payload).pipe(
            map((res: ValidateOtpRespDto) => res.data), 
            catchError((error: HttpErrorResponse) => {
                return throwError(() => error.error);
            })
        );
    }
}